import type { Theme } from '@mui/material/styles';
import { useTheme as useMuiTheme } from '@mui/material/styles';

/**
 * Custom hook to access the HHGlobal theme
 * Provides type-safe access to both Material UI theme and custom HHGlobal design system colors
 *
 * @example
 * ```tsx
 * const theme = useTheme();
 * const textColor = theme.hhglobal.purpose.textStrong;
 * const infoColor = theme.hhglobal.utility.info[900];
 * ```
 */
export const useTheme = (): Theme => {
  return useMuiTheme();
};
